// third-party
import { configureStore, combineReducers } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';

// project import
import menuReducer from './reducers/menu';
import auctionReducer from './auction/auction.slice';
import userReducer from './user/user.slice';
import { VehicleBiddingApi } from './vehicleBidding.api';

// ==============================|| REDUX TOOLKIT - MAIN STORE ||============================== //

const persistConfig = {
  key: 'jnrvehiclebidding',
  storage,
  blacklist: ['menu', 'auction', VehicleBiddingApi.reducerPath],
};
const rootReducer = combineReducers({
  [VehicleBiddingApi.reducerPath]: VehicleBiddingApi.reducer,
  menu: menuReducer,
  user: userReducer,
  auction: auctionReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(VehicleBiddingApi.middleware),
});

const { dispatch } = store;
export { store, dispatch };
export const persistor = persistStore(store);
